import type { TimelineEvent } from '../../../patient-files/actions/types';

// Shared page size for the version-history fetches (Dx report / SDI / RDI).
// A fetch that returns exactly this many raw events may be truncated -
// callers should treat that as "there may be more" rather than "this is all".
export const TIMELINE_VERSION_FETCH_LIMIT = 50;

// Reports imported off Monday all carry version 0, so the version number
// alone can't order them — tie-break on the date they were filed.
export function sortEventsLatestFirst(events: TimelineEvent[]): TimelineEvent[] {
    return [...events].sort(
        (a, b) => b.version - a.version || b.createdAt.localeCompare(a.createdAt)
    );
}
